import { render, staticRenderFns } from "./MySecuritySettings.vue?vue&type=template&id=72064b99&"
import script from "./MySecuritySettings.vue?vue&type=script&lang=js&"
export * from "./MySecuritySettings.vue?vue&type=script&lang=js&"
import style0 from "./MySecuritySettings.vue?vue&type=style&index=0&id=72064b99&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports